import { create } from 'zustand';

interface ShopPopupState {
  isOpen: boolean;
  /** Analytics attribution for platform_shop_opened: 'lobby' or a game id. */
  from: string;
  open: (from: string) => void;
  close: () => void;
}

/**
 * Module 28 — open/close state for the single app-level ShopPopup
 * (ShopPopupContainer, mounted once in App.tsx beside the router so it can
 * overlay the Lobby and any running game alike). Lives in the app, not a
 * package: callers inside the React tree use the hook; the composition root
 * bridges games to it via IGameContext (games never import this module).
 */
export const useShopPopupStore = create<ShopPopupState>((set) => ({
  isOpen: false,
  from: 'lobby',
  open: (from) => set({ isOpen: true, from }),
  close: () => set({ isOpen: false }),
}));
